import type React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import {
  ActionsRow,
  CloseButton,
  ConfirmBody,
  ConfirmButton,
  ConfirmMessage,
  ConfirmTitle,
  HeaderWrap,
  SecondaryButton,
  StyledConfirmDialog,
} from '../../pages/organisations/components/OrganisationStatusConfirmDialog.styles'

interface ConfirmDialogProps {
  open: boolean
  title: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  isLoading?: boolean
  onClose: () => void
  onConfirm: () => void
}

const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel = 'Yes',
  cancelLabel = 'Cancel',
  isLoading = false,
  onClose,
  onConfirm,
}: ConfirmDialogProps): React.JSX.Element => (
  <StyledConfirmDialog open={open} onClose={onClose} fullWidth maxWidth="xs">
    <ConfirmBody>
      <HeaderWrap>
        <ConfirmTitle>{title}</ConfirmTitle>
        <CloseButton size="small" onClick={onClose} disabled={isLoading}>
          <CloseIcon />
        </CloseButton>
      </HeaderWrap>

      <ConfirmMessage>{message}</ConfirmMessage>

      <ActionsRow>
        <ConfirmButton variant="contained" color="error" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? 'Please wait...' : confirmLabel}
        </ConfirmButton>
        <SecondaryButton onClick={onClose} disabled={isLoading}>
          {cancelLabel}
        </SecondaryButton>
      </ActionsRow>
    </ConfirmBody>
  </StyledConfirmDialog>
)

export default ConfirmDialog
